'use client';

import { ParallaxProvider } from 'react-scroll-parallax';

export function Providers({ children }: { children: React.ReactNode }) {
    return <ParallaxProvider data-component-id="src/app/providers.tsx:6:11" data-component-path="src/app/providers.tsx" data-component-line="6" data-component-file="providers.tsx" data-component-name="ParallaxProvider" data-component-content="%7B%22elementName%22%3A%22ParallaxProvider%22%7D">{children}</ParallaxProvider>;
}